module.exports = __webpack_public_path__ + "static/img/matrizRisco.dec9360.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/apr/matrizRisco.jpg
// module id = m7uM
// module chunks = 0